var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCac40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A8173",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.968 36h3.322v-3H27v-2.69h-1.71V20h-4.93l-7.045 10.192V33h8.653v3Zm-5.266-5.605v-.086l5.255-7.705h.08v7.791h-5.335ZM35.88 36c4.236 0 6.805-3.076 6.805-7.995v-.021c0-4.919-2.569-7.984-6.805-7.984s-6.805 3.065-6.805 7.984v.021c0 4.92 2.57 7.995 6.805 7.995Zm0-2.593c-2.083 0-3.275-2.004-3.275-5.402v-.021c0-3.397 1.192-5.39 3.275-5.39s3.276 1.993 3.276 5.39v.021c0 3.398-1.193 5.402-3.276 5.402Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCac40);
export default __webpack_public_path__ + "static/media/cac40.14d57ad9637d30358447c8e508a9fd74.svg";
export { ForwardRef as ReactComponent };